<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="translations.actionRequest"
        :loading="loading"
        class="mt-5"
        height="auto"
        :hide-default-footer="!canAct"
        :error-message="errorMessage"
        @submit="openViberDialog('Request')"
    >
        <b-text-field
            v-if="canAct"
            :label="translations.senderAliasName[lang]"
            v-model="alias"
            :disabled="!canAct"
        ></b-text-field>
        <v-col v-else>
            <span class="text-subtitle-2"
                >{{ translations.senderAliasName[lang] }}: </span
            >
            <span class="text-body-1 font-weight-regular">{{ alias }}</span>
            <v-tooltip v-if="superUser && configuration.viber_requested_alias_name" color="secondary" top>
                <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-0 mb-1 ml-2"
                        icon
                        v-on="on"
                        @click="openViberDialog('Confirm')"
                    >
                        <v-icon
                            class="b-social-icon"
                            color="green"
                            v-text="icons.mdiCheck"
                        ></v-icon>
                    </v-btn>
                </template>
                <span class="font-weight-bold">{{
                    translations.actionConfirm[lang]
                }}</span>
            </v-tooltip>
            <v-tooltip v-if="superUser && configuration.viber_requested_alias_name" color="secondary" top>
                <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-1 mb-1"
                        icon
                        v-on="on"
                        @click="openViberDialog('Cancel')"
                    >
                        <v-icon
                            class="b-social-icon mr-n1"
                            color="red"
                            v-text="icons.mdiClose"
                        ></v-icon>
                    </v-btn>
                </template>
                <span class="font-weight-bold">{{
                    translations.actionCancel[lang]
                }}</span>
            </v-tooltip>
        </v-col>
        <span v-if="configuration.viber_requested_alias_name">
            {{ translations.aliasRequested1[lang] }}
            <span class="text-body-1 font-weight-bold">{{ alias }}</span
            >{{ translations.aliasRequested2[lang] }}</span
        >
        <span v-if="configuration.viber_sender_alias_name">
            {{ translations.aliasExists[lang] }}</span
        >
      

        <v-dialog  v-model="viberDialog" max-width="500">
            <b-card
                
                :title="this.translations.title[this.lang]"
                @cancel="closeViberDialog"
                @submit="submitViberConfiguration(action, alias)"
                :loading="loading"
                :type="action == 'Cancel' ? 'delete' : ''"
                :submit-text="
                    translations[
                        `action${action}Dialog`
                    ]
                "
                :cancel-text="translations.close"
            >
                <v-col cols="12" class="pr-2">
                    <span>
                        {{ translations.actionQuestion1[lang] }}
                        <span class="text-body-2 font-weight-bold">{{
                            action && (translations[
                                `action${action}Dialog`
                            ][lang]).toUpperCase()
                        }}</span
                        >{{ translations.actionQuestion2[lang] }}</span
                    >
                    <span class="text-body-1 font-weight-bold">{{
                        alias
                    }}</span>?
                </v-col>
            </b-card>
        </v-dialog>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/viberConfiguration";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { mdiCheck, mdiClose } from "@mdi/js";

export default {
    name: "ViberConfiguration",

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiCheck,
                mdiClose
            },
            alias: "",
            viberDialog: false,
            action: ""
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading
                .viber_configuration;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .viber_configuration;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .viber_configuration;
        },
        
        ...mapState(["superUser"]),

        ...mapState("loyaltyPanel/businessProfile", [
            "viberConfiguration",
        ]),

        configuration() {
            return this.viberConfiguration || {};
        },
        canAct() {
            return !(
                this.configuration?.viber_sender_alias_name ||
                this.configuration?.viber_requested_alias_name
            );
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "viberAliasRequest",
            "viberAliasConfirm",
            "viberAliasCancel"
        ]),
        ...mapMutations([
            "setNotification",
        ]),

        openViberDialog(action) {
            this.action = action;
            this.viberDialog = true;
        },

        closeViberDialog() {
            this.viberDialog = false;
        },

        async submitViberConfiguration(action, alias) {
           let res = await this[`viberAlias${action}`]({
                type: "viber_configuration",
                body: { viber_requested_alias_name: alias }
            });
            if(res?.status == 'success'){
                this.closeViberDialog()
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations[`success${action}`][this.lang] + alias
                })
            }
        }
    },

    watch: {
        configuration: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.alias =
                        val?.viber_sender_alias_name ||
                        val?.viber_requested_alias_name ||
                        "";
                }
            },
            deep: true
        },
        viberDialog: {
            immediate: true,
            handler(val, prev) {
                if (!val) { 
                    this.$nextTick(() => {
                        this.action = "";
                    });
                }
            },
        }
    }
};
</script>
